
import { settingsItems } from '@/lib/mock-data';
import { SubscriptionStatusCard } from '@/components/dashboard/subscription-status-card';
import { useHistoryStore } from '@/lib/store/history-store';

export function SettingsList() {
  const userId = useHistoryStore((state) => state.userId);

  const handleClick = (type: string) => {
    switch (type) {
      case 'subscription':
        window.location.href = 'https://polar.sh/purchases';
        break;
      case 'restore':
        const restoreSubject = encodeURIComponent('Restore Purchase - Deepcheck');
        const restoreBody = encodeURIComponent(`I have this User ID: ${userId}. I want to restore my purchase.`);
        window.location.href = `mailto:shauv@hi2.in?subject=${restoreSubject}&body=${restoreBody}`;
        break;
      case 'feedback':
        const subject = encodeURIComponent('Feedback for Deepcheck');
        const body = encodeURIComponent(`I have this User ID: ${userId}. I want to give feedback.\n\n`);
        window.location.href = `mailto:shauv@hi2.in?subject=${subject}&body=${body}`;
        break;
      case 'rate':
        console.log('Rate app');
        break;
    }
  };

  return (
    <div className="space-y-3">
      {/* Subscription Status Card */}
      <SubscriptionStatusCard />

      {settingsItems.map((item) => (
        <div key={item.id}>
          {item.type === 'user-id' ? (
            <div className="p-4 bg-white border border-gray-200 rounded-lg">
              <div className="text-sm">
                <span className="font-medium text-gray-700">{item.label}:</span>{' '}
                <span className="text-gray-600 break-all">{userId}</span>
              </div>
            </div>
          ) : (
            <button
              onClick={() => handleClick(item.type)}
              className="w-full p-4 bg-white border border-gray-200 rounded-lg hover:border-gray-300 transition-colors text-left"
            >
              <span className="font-medium text-gray-900">{item.label}</span>
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
